import "./UpdatesTicker.css";

const updates = [
  "Be alert: A targeted phishing scam is circulating via SMS, falsely claiming “non-delivery due to failed attempts” and redirecting users to fraudulent websites",
  "Please do not transfer money to payment links that are not shared from JPSY's official accounts",
  "JPSY does not require OTP or credentials for address confirmation for your delivery",
  "Our Customer Support team is reachable only from our website or app. Login with your phone number and raise your support request with us",
];

function UpdatesGroup({ hidden = false }) {
  return (
    <div className="updates-group" aria-hidden={hidden}>
      {updates.map((update) => (
        <p className="updates-item" key={update}>
          <span className="updates-separator" aria-hidden="true">•</span>
          {update}
        </p>
      ))}
    </div>
  );
}

export default function UpdatesTicker() {
  return (
    <section className="updates-ticker" aria-label="Security updates">
      <div className="updates-window" tabIndex={0} aria-label="Scrolling security updates">
        <div className="updates-track">
          <UpdatesGroup />
          <UpdatesGroup hidden />
        </div>
      </div>
    </section>
  );
}
